<!--  -->
<template>
  <div class="wrapper">
    <div class="literature-list">
      <div class="literature" ref="literature">
        <div class="operation-buttons">
          <el-button type="primary" class="back-btn reset-btn" @click="backToSearch">Back to Search</el-button>
          <el-button type="primary" class="download-btn search-btn" @click="download">Download</el-button>
        </div>
        <v-table :tableData="tableData"></v-table>
      </div>
      <el-pagination @current-change="handleCurrentChange" :total="literatureTotalCount" :current-page="currentPage" :page-size="per_page" layout="prev,slot,next">
        <span class="rightPagination">
          {{currentPage}}/{{totalPage}}
        </span>
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { getDownloadList, download } from '@/api/index'
import VTable from '@/components/table/literature.vue'
import VPage from '@/components/pagenation/index'
export default {
  components: {
    VTable,
    VPage
  },
  data () {
    return {
      totalPage: 1,
      tableData: [],
      literatureTotalCount: 0,
      currentPage: 1,
      per_page: 10
    }
  },
  // 生命周期 - 创建完成（访问当前this实例）
  created () {},
  // 生命周期 - 挂载完成（访问DOM元素）
  mounted () {
    this.getDownloadList()
  },
  methods: {
    backToSearch () {
      this.$router.push({
        name: 'Download'
      })
    },
    download () {
      const query = this.$route.query
      this.$bus.$emit('loading', true, 'Downloading...')
      //   download(query).then((res) => {
      //     if (res.status == 200) {
      //       let url = window.URL.createObjectURL(new Blob([res.data]));
      //       let fileName = decodeURI(
      //         res.headers["content-disposition"].split(";")[1].split("=")[1]
      //       );
      //       let link = document.createElement("a");
      //       link.style.display = "none";
      //       link.href = url;
      //       link.setAttribute("download", fileName);
      //       document.body.appendChild(link);
      //       link.click();
      //       document.body.removeChild(link);
      //       window.URL.revokeObjectURL(url);
      //       this.$bus.$emit('loading','success','success');
      //     }else{
      //         this.$bus.$emit('loading','error','error');
      //     }
      //   }).finally(e => {
      //       setTimeout(() => {
      //           this.$bus.$emit('loading',false);
      //       },1000)
      //   });
      download(query)
        .then((res) => {
          if (res.status == 200 && res.headers['content-disposition']) {
            const url = window.URL.createObjectURL(new Blob([res.data]))
            const fileName = decodeURI(
              res.headers['content-disposition'].split(';')[1].split('=')[1]
            )
            const link = document.createElement('a')
            link.style.display = 'none'
            link.href = url
            link.setAttribute('download', fileName)
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            window.URL.revokeObjectURL(url)
            this.$bus.$emit('loading', 'success', 'success')
          } else {
            this.$bus.$emit('loading', 'error', 'error')
          }
        })
        .finally((e) => {
          setTimeout(() => {
            this.$bus.$emit('loading', false)
          }, 1000)
        })
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getDownloadList()
    },
    getResult (page) {
      const query = this.$route.query
      return getDownloadList(query)
    },
    getDownloadList () {
      this.$bus.$emit('loading', true, 'Searching...')
      const query = this.$route.query
      getDownloadList(query)
        .then((res) => {
          if (res.data.data) {
            this.$bus.$emit('loading', 'success', 'success')
          } else {
            this.$bus.$emit('loading', 'error', 'error')
          }
          const data = res.data?.data || []
          const meta = res.data?.meta || {}
          //   let { totalCount = 0, totalPage = 0 } = meta;
          //   this.totalPage = totalPage;
          //   this.literatureTotalCount = totalCount;
          const { adminList, fossilList, speciesList } = data
          const result = []
          console.log(adminList, fossilList, speciesList)
          //   this.$set(this, "tableData", data);
        })
        .finally((e) => {
          setTimeout(() => {
            this.$bus.$emit('loading', false)
          }, 1000)
        })
    },
    returnTableData (data) {},
    searchLiterature () {
      this.currentPage = 1
      this.getDownloadList()
    }
  },
  watch: {}
}
</script>
<style>
.literature-list {
  position: relative;
  /* max-height: 800px; */
  padding: 0 0 40px;
  width: 100%;
}
.el-table th.el-table__cell > .cell {
  font-weight: 600;
}
.operation-buttons {
  display: flex;
  justify-content: space-between;
  margin-bottom: 22px;
}
.operation-buttons .el-button {
  width: 180px;
  height: 35px;
  font-size: 16px;

  background-repeat: no-repeat;
  background-size: 15px 14px;
  background-position: 25px 10px;
}
.operation-buttons .back-btn {
  text-indent: 44px;
  background-image: url("../../assets/images/back.png");
}
.operation-buttons .download-btn {
  background-image: url("../../assets/images/download.png");
}
</style>
